export const outsideClick = {
    mounted (el, binding) {
        function onClick (event) {
            if (!el.contains(event.target)) {
                binding.value(); // 调用传入的函数处理外部点击事件
            }
        }
        el.__vueClickOutside__ = onClick;
        document.addEventListener('click', onClick);
    },
    unmounted (el) {
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
    },
};
